import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  effect,
  viewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import {
  Observable,
  Subject,
  Subscription,
  interval,
  of,
  switchMap,
  takeUntil,
} from 'rxjs';

import { inject } from '@angular/core';
import { PermissionService } from 'src/app/core/services/authentication/permission.service';
import { AppNotificationService } from './core/services/app-notification.service';
import { AppStateService } from './core/services/app-state.service';
import { AppStyleService } from './core/services/app-style.service';
import { AuthTokenService } from './core/services/authentication/auth-token.service';
import { TranslationService } from './i18n';
import { locale as enLang } from './i18n/en';
import { locale as faLang } from './i18n/fa';
import { AppIntroService } from './layout/components/app-intro/app-intro.service';
import { NotificationsComponent } from './layout/components/explore-main-drawer/notifications/notifications.component';

@Component({
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit {
  readonly notificationsComponent = viewChild(NotificationsComponent);

  appIntroService = inject(AppIntroService);
  appStyleService = inject(AppStyleService);

  isVisibleAppIntro$: Observable<boolean>;
  appChartFont: string = 'Vazirmatn';
  isLtr: boolean = false;
  header: string;
  intervalSubscription: Subscription;
  timerIntervalId: any;
  isShowNotification: boolean = false;
  protected onDestroy$ = new Subject<void>();

  constructor(
    private translationService: TranslationService,
    private permissionService: PermissionService,
    private router: Router,
    private appNotificationService: AppNotificationService
  ) {
    this.translationService.loadTranslations(faLang, enLang);
    effect(() => {
      this.permissionService.userState();
      this.checkForceChangePassword();
      this.appIntroService.visible();
      this.handleAppIntroDisplayStatus();
    });
  }

  ngOnInit() {
    this.detectChangeStorage();
    this.configAppChartFont();
    if (AuthTokenService.getAccessToken()) {
      this.getNotifications();
      this.changeIsShowNotification();
    }

    this.appStyleService.initThemeMode();
  }

  changeIsShowNotification() {
    if (this.intervalSubscription) this.intervalSubscription.unsubscribe();
    this.isShowNotification = true;
    this.autoUpdateNotifications();
  }

  autoUpdateNotifications() {
    this.startTimer();
    this.intervalSubscription = interval(26000) // Set the interval to 25000 milliseconds (25 seconds)
      .pipe(takeUntil(this.onDestroy$))
      .pipe(
        switchMap((res) => {
          if (this.isShowNotification)
            return this.appNotificationService.getNotificationsApi();
          else return of({});
        })
      )
      .subscribe((res: any) => {
        this.startTimer();
      });
  }
  startTimer() {
    if (this.timerIntervalId) clearInterval(this.timerIntervalId);
    this.appNotificationService.notificationTimerValue.set(0);
    this.timerIntervalId = setInterval(() => {
      let notificationTimerValue =
        this.appNotificationService.notificationTimerValue();
      this.appNotificationService.notificationTimerValue.set(0);
      if (notificationTimerValue <= 25)
        this.appNotificationService.notificationTimerValue.set(
          (notificationTimerValue += 1)
        );
    }, 1000);
  }

  onUpdateNotifications() {
    const notificationsComponent = this.notificationsComponent();
    if (notificationsComponent)
      notificationsComponent.getNotificationListApi();
  }

  ngAfterViewInit(): void {
    this.header = AppStateService.header;
    var head = document.getElementsByTagName('head')[0];
    // اضافه کردن رشته HTML به تگ head
    head.innerHTML += this.header;
  }

  getNotifications() {
    this.appNotificationService.getNotificationsApi().subscribe();
  }

  checkForceChangePassword() {
    if (this.permissionService.userState()?.changePasswordRequired)
      this.router.navigate(['/account/change-password']);
  }

  detectChangeStorage() {
    addEventListener('storage', (event: StorageEvent) => {
      if (event.key == 'act' || event.key == 'rft')
        window.location.replace(window.location.origin);
    });
  }

  handleAppIntroDisplayStatus() {
    if (this.appIntroService.visible())
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    else document.getElementsByTagName('html')[0].style.overflow = 'initial';
  }

  configAppChartFont() {
    this.isLtr =
      document.getElementsByTagName('html')[0].getAttribute('dir') == 'ltr';
    if (this.isLtr) this.appChartFont = 'Poppins';
    else this.appChartFont = 'Vazirmatn';
    Chart.defaults.font.family = this.appChartFont;
    Chart.defaults.font.size = 14;
  }

  ngOnDestroy() {
    this.unSubs();
    this.onDestroy$.complete();
  }

  unSubs() {
    this.onDestroy$.next();
  }
}
